/**
 * Shared HTTP header names used by both the browser API client and the backend.
 * Kept here (rather than in api-client.ts) so the server can import the constant
 * without pulling in the whole client module and its dependencies.
 */

/**
 * Header the browser sends while an admin impersonates a user. Its value is that
 * user's id. The backend answers the request as that user at normal-user
 * permission level, and rejects anything but a read. See the gears-api
 * authentication middleware and the api-client.
 */
export const IMPERSONATE_USER_HEADER = 'racemap-impersonate-user';
